// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1570":"cc00fa56","2281":"208535e5","2574":"65fd8607","6016":"b824eba2"}[chunkId] + ".chunk.css";
};